import React from "react";
import { Link, useLocation } from "react-router-dom";

const BreadcrumbPortal = ({ excludedPaths = [] }) => {
  const location = useLocation();
  const paths = location.pathname.split("/").filter((path) => path !== "");

  return (
    <div className=" text-white">
      <nav className="flex flex-col md:flex-row">
        <div className="flex p-0 items-center">
          <span className="mr-3 text-xs md:text-base">Anda di sini : </span>
          <ol className="list-none p-0 flex">
            {paths.map((path, index) => {
              const url = `/${paths.slice(0, index + 1).join("/")}`;
              const isLast = index === paths.length - 1;

              // Tambahkan kondisi untuk mengabaikan path yang ada dalam excludedPaths
              if (excludedPaths.includes(path)) {
                return null;
              }

              return (
                <li
                  key={index}
                  className="flex items-center text-xs md:text-base"
                >
                  {!isLast ? (
                    <Link
                      to={url}
                      className="text-blue-300 hover:underline text-xs md:text-base"
                    >
                      {path.charAt(0).toUpperCase() + path.slice(1)}
                    </Link>
                  ) : (
                    <span className="text-white dark:text-white text-xs md:text-base">
                      {path.charAt(0).toUpperCase() + path.slice(1)}
                    </span>
                  )}
                  {!isLast && (
                    <span className="text-white dark:text-white mx-1 text-xs md:text-base">
                      /
                    </span>
                  )}
                </li>
              );
            })}
          </ol>
        </div>
      </nav>
    </div>
  );
};

export default BreadcrumbPortal;
